import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import { loadReCaptcha } from 'react-recaptcha-v3'
import { ReCaptcha } from 'react-recaptcha-v3'
import Validators from '../utils/validators'

@observer(['globals', 'users'])
export default class ForgotPassword extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: '',
    }

    document.body.className = 'login'
    document.body.style.backgroundColor = '#eee'
  }

  componentDidMount() {
    loadReCaptcha('6LfGdKAUAAAAAFtHSKJwnMWn9UcwFdcLVYFqq6bF');
  }

  editEmail(e) {
    this.setState({
      email: e.target.value
    })
  }

  handleForgotPasswordClick() {
    if (Validators.validEmail(this.state.email)) {
      console.log('Email Address: ', this.state.email);
      this.props.users.forgotPassword(this.state.email, (data) => {
        alert(data.forgotPassword.data.message);
      })
    }
    else {
      alert('Please enter a valid email address.');
    }
  }

  returnToLogin() {
    browserHistory.push('/');
  }

  render() {

    return (
      <div className="login">
        <div>
          <div className="login_wrapper">
            <div className="animate form login_form">
              <section className="login_content">
              <img alt="GPS Leaders" src="/images/logo-white.png" /><br />
                <form>
                  <h1>Forgot Password</h1>
                  <div>
                    <input id="email" style={
                      {
                        height: "34px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        backgroundColor: "#FFF"
                      }
                    } type="text" className="form-control" placeholder="Email" required="" onChange={ this.editEmail.bind(this) } />
                  </div>
                  <div>
                    <ReCaptcha
                      sitekey="6LfGdKAUAAAAAFtHSKJwnMWn9UcwFdcLVYFqq6bF"
                    />
                  </div>
                  <div>
                    <Button onClick={ this.handleForgotPasswordClick.bind(this) }>Send Reset Email</Button>
                  </div>
                  <div className="clearfix"></div>
                  <div className="separator">
                    <div className="clearfix"></div>
                    <div>
                      <h2>GPS Leaders CRM</h2>
                      <Button onClick={ this.returnToLogin.bind(this) }>Return to Login Page</Button>
                      <p>©2019 All Rights Reserved. This is a GPS Leaders product.</p>
                    </div>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/forgotpassword.js